import { LprExportStatus } from '@lib/vehicle-intelligence/models/alpr-export-status.enum';
import { QueriesSearchParams } from '@lib/vehicle-intelligence/utils';

import { ILprExportParamsInterface } from './lpr-export-params.interface';

export interface LprExportTriggerRequest {
  reportFormat: 'csv';
  params: ILprExportParamsInterface;
}

export interface LprExportTriggerResponse {
  id: string;
  status: LprExportStatus;
  createdAt: string;
  downloadUrl?: string;
  message?: string;
}

export interface ILprExportInterface {
  id: string;
  updatedTimestamp: Date;
  reportFormat: string;
  status: LprExportStatus;
  params: ILprExportParamsInterface;
  completedAt: Date;
  startedAt: Date;
  fileSize: number;
}
